import { render, staticRenderFns } from "./Categorys.vue?vue&type=template&id=1de5ca44&scoped=true"
import script from "./Categorys.vue?vue&type=script&lang=js"
export * from "./Categorys.vue?vue&type=script&lang=js"
import style0 from "./Categorys.vue?vue&type=style&index=0&id=1de5ca44&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"
import style1 from "./Categorys.vue?vue&type=style&index=1&id=1de5ca44&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de5ca44",
  null
  
)

export default component.exports